import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Grid, makeStyles } from '@material-ui/core';

import Vehicle from './Vehicle';
import VehicleCity from './VehicleCity';
import VehicleOwner from './VehicleOwner';
import CompanyName from './CompanyName';
import Itinerary from './Itinerary';
import Contract from './Contract';

import { SERVICES_PROPERTIES } from 'app/config/services';

import styles from './styles';
const useStyles = makeStyles(styles);

function Request(props) {
  const classes = useStyles();

  const {
    oldRequest,
    selectedChangeType,
    setFieldValue,
    oldLicense,
    oldService,
    previousRequestCode,
  } = props;

  useEffect(() => {
    const init = () => {
      if (previousRequestCode) {
        setFieldValue('cdSolicitacaoAnterior', previousRequestCode);
      }
      if (oldLicense) {
        setFieldValue(
          'cdSolicitacaoOrigem',
          oldLicense.cdSolicitacaoOrigem || oldLicense.cdSolicitacao
        );
      }
      if (oldService) {
        setFieldValue('cdServicoOrigem', oldService.cdServico);
      }
      if (selectedChangeType) {
        setFieldValue('cdTipoAlteracaoLicenca', Number(selectedChangeType));
      }
    };
    init();
  }, [oldRequest, oldService, selectedChangeType, setFieldValue, previousRequestCode, oldLicense]);

  const service = useSelector(state => state.services.details);

  const configurator = useMemo(() => {
    if (service.cdServico && SERVICES_PROPERTIES[service.cdServico].configurator) {
      return SERVICES_PROPERTIES[service.cdServico].configurator;
    }
    return {};
  }, [service.cdServico]);

  return (
    <Grid container spacing={3} className={classes.containerMainData}>
      {configurator[selectedChangeType].hasVehicle && <Vehicle {...props} classes={classes} />}
      {configurator[selectedChangeType].hasVehicleCity && (
        <VehicleCity {...props} classes={classes} />
      )}
      {configurator[selectedChangeType].hasVehicleOwner && (
        <VehicleOwner {...props} classes={classes} />
      )}
      {configurator[selectedChangeType].hasCompanyName && (
        <CompanyName {...props} classes={classes} />
      )}
      {configurator[selectedChangeType].hasItinerary && <Itinerary {...props} classes={classes} />}
      {configurator[selectedChangeType].hasContract && <Contract {...props} classes={classes} />}
    </Grid>
  );
}

export default Request;
